import { Injectable } from '@angular/core';
import UIkit from './lib/uikit';

@Injectable()
export class NotificationService {
  constructor() {}

  public show(options: any | {
    message: string;
    status?: string;
    timeout?: number;
    group?: string;
    pos?: string;
  }) {
    if (options instanceof String) options = {message: options};

    const defaults = {pos: 'bottom-left'};

    options = Object.assign(defaults, options);
    UIkit.notification(options);
  }
}
